// Modified from cart-notification.js
class Notification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.transitionPromise = null;

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
  }

  async open(content) {
    if (this.notification.classList.contains("active")) {
      this.close();
    }
    await this.transitionPromise;
    if (this.header) this.header.reveal();
    this.notification.innerHTML = content.innerHTML;
    this.transitionPromise = new Promise((resolve) => {
      this.notification.classList.add("active");
      this.notification.addEventListener(
        "transitionend",
        () => {
          this.notification.focus();
          trapFocus(this.notification);
          resolve();
        },
        { once: true }
      );
    });
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.transitionPromise = new Promise((resolve) => {
      this.notification.classList.remove("active");
      this.notification.addEventListener("transitionend", resolve, {
        once: true,
      });
    });
    document.body.removeEventListener("click", this.onBodyClick);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("notification")) {
      this.close();
    }
  }
}

customElements.define("sticky-notification", Notification);

class StickyNotificationContent extends HTMLElement {
  constructor() {
    super();
    this.notification = document.querySelector("sticky-notification");
  }

  show() {
    this.notification.open(this);
  }

  hide() {
    this.notification.close(this);
  }
}

customElements.define("sticky-notification-content", StickyNotificationContent);
